export default {
  no_results: {
    title: 'Niciun rezultat pentru „{{search}}"',
    desc: 'Ne pare rău, nu am găsit niciun rezultat. Încearcă un alt termen de căutare.',
  },
  empty_menu: {
    title: 'Niciun articol disponibil încă',
    desc: 'Meniul nu are nimic de afișat momentan. Revino în curând.',
  },
};
